module.exports = __webpack_public_path__ + "media/images/games/35gender/tinied/catspr-f8ca31e05c5da081f271438a6515f173.png";